var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"d-flex align-center v-label theme--light mt-1 b-hint",class:{
      'b-hint-bold': _vm.bold,
      'mb-2': _vm.marginBottom,
    },staticStyle:{"font-size":"0.9rem"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("mdi-information-outline")]),(_vm.withHTML)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.hintText)}}):_c('div',{class:{ 'b-hint-underlined': _vm.underlined }},[_vm._v(" "+_vm._s(_vm.hintText)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }